import React from 'react';
import { Logo } from './Logo';
import { Cta } from './Cta';
import { useScore } from './ScoreContext';
export function Nav() {
  const {
    answeredCount,
    openDiagnostic
  } = useScore();
  const shortLabel = answeredCount === 0 ? 'Get Your Score' : answeredCount < 4 ? 'Continue Score' : 'Finish Score';
  const fullLabel = answeredCount === 0 ? 'Get Your Reader-to-Revenue Score' : answeredCount < 4 ? 'Continue Your Score' : 'Finish Your Score';
  return <header className="site-header sticky top-0 z-40 w-full border-b border-gray-100 bg-paper/80 shadow-sm backdrop-blur-md" data-id="element-318" data-mp="1fxuted4vq2el">
      <div className="site-header-inner mx-auto flex w-full max-w-[90rem] items-center justify-between gap-3 px-4 py-3 sm:px-6 md:px-10 md:py-5" data-id="element-319" data-mp="1ppqp5hjhtgfn">
        <Logo className="min-w-0 shrink-0" data-id="element-320" data-mp="1uo24g7sk4j59" />
        <Cta variant="primary" size="sm" onClick={openDiagnostic} aria-label={fullLabel} className="min-h-[44px] shrink-0 whitespace-nowrap px-3.5 shadow-sm hover:shadow sm:px-5" data-id="element-321" data-mp="1yqgk6j0xj2sb">
          <span className="sm:hidden" data-id="element-322" data-mp="23mx6r8shd93a">{shortLabel}</span>
          <span className="hidden sm:inline" data-id="element-323" data-mp="1y6q8021qby76">{fullLabel}</span>
        </Cta>
      </div>
    </header>;
}